import sample_1 from './100_1240.jpg';
import sample_2 from './100_1251.jpg';

export const eurocleanImpressions = {
    sample_1,
    sample_2,
};
